import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import Icon from '@material-ui/core/Icon';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import FilterSelect from './inputs/FilterSelect'

import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CustomRangePicker from './inputs/CustomRangePicker'

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
});

function MobileFilters(props) {
  const { classes, filters, handleFilter, clearFilters, handleDates, picker, filterControls } = props;
  return (
    <div className={`${classes.root} mt-24 mb-24`}>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.heading}>Filters</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
					<div className="d-flex flex-column w-100 expansion-panel-wrapper">

              {
                filterControls.map( (fc, index) => {
                  if (fc.filter_type === "search") {
                    return (
                      <div key={`fiter_${index}`} className="mb-8 w-100 d-flex expansion-panel-inner-wrapper">
                        <FilterSelect
                          filter_type="search"
                          filters={filters}
                          name={fc.name}
                          onChange={handleFilter}
                        />
                      </div>
                    )
                  } else if (fc.filter_type === "date") {
                    return (
                      <div key={`fiter_${index}`} className="mb-8 w-100 d-flex expansion-panel-inner-wrapper">
                        <CustomRangePicker
                          key={`fiter_${index}`}
                          withPortal={true}
                          numberOfMonths={1}
                          handleChange={handleDates}
                          startLabel={fc.startLabel}
                          endLabel={fc.endLabel}
                          ref={picker}
                        />
                      </div>
                    )
                  } else {
                    return (
                      <div key={`fiter_${index}`} className="mb-8 w-100 d-flex expansion-panel-inner-wrapper">
                        <FilterSelect
                          key={`fiter_${index}`}
                          filters={filters}
                          name={fc.name}
                          onChange={handleFilter}
                          collection={fc.collection}
                          valueField={fc.valueField}
                        />
                      </div>
                    )
                  }
                })
              }


            <div
              className="mt-16 w-100 d-flex align-items-center c-black054 pointer body2"
              onClick={clearFilters}
            >
              <Icon className="mr-8">cancel</Icon>
              Clear All Filters
            </div>
					</div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}

export default withStyles(styles)(MobileFilters);



// WEBPACK FOOTER //
// ./src/js/components/MobileFilters.js